/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UmbrellaCompanySearchResult } from './';
import {
    UmbrellaCompanySearchResultFromJSON,
    UmbrellaCompanySearchResultFromJSONTyped,
    UmbrellaCompanySearchResultToJSON,
} from './';

/**
 * 
 * @export
 * @interface UmbrellaCompanySearchResults
 */
export interface UmbrellaCompanySearchResults {
    /**
     * 
     * @type {Array<UmbrellaCompanySearchResult>}
     * @memberof UmbrellaCompanySearchResults
     */
    results: Array<UmbrellaCompanySearchResult>;
}

/**
 * Check if a given object implements the UmbrellaCompanySearchResults interface.
 */
export function instanceOfUmbrellaCompanySearchResults(value: object): value is UmbrellaCompanySearchResults {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function UmbrellaCompanySearchResultsFromJSON(json: any): UmbrellaCompanySearchResults {
    return UmbrellaCompanySearchResultsFromJSONTyped(json, false);
}

export function UmbrellaCompanySearchResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaCompanySearchResults {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(UmbrellaCompanySearchResultFromJSON)),
    };
}

export function UmbrellaCompanySearchResultsToJSON(value?: UmbrellaCompanySearchResults | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map((v) => UmbrellaCompanySearchResultToJSON(v))),
    };
}

